
////////////////////////////////////
//  Header Menu
////////////////////////////////////

function headerPadding(){
  var headerHeight = $('header').innerHeight();
  $('.l-main').css('padding-top', headerHeight + 1);
}

function header(){
	$(document).on('click', '.js-hamburger', function(){
	  $(this).toggleClass("is-active");
	  $('body').toggleClass("is-active");
	  $(".js-overlay,.js-menu").toggleClass("is-active");
	  $(".js-overlay").fadeToggle(300);
	});
}

$(function(){
	header();
  	headerPadding();
});

let resizeTimer;

$(window).resize(function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    headerPadding();
  }, 500);
});

////////////////////////////////////
//  Fixed Btn
////////////////////////////////////

function PageTopAnime() {

    var scroll = $(window).scrollTop(); //スクロール値を取得
    if (scroll >= 200){//200pxスクロールしたら
      $('.js-fixed__btn').removeClass('is-down');   // is-downというクラス名を除去して
      $('.js-fixed__btn').addClass('is-up');      // is-upというクラス名を追加して出現
    }else{//それ以外は
      if($('.js-fixed__btn').hasClass('is-up')){//is-upというクラス名が既に付与されていたら
        $('.js-fixed__btn').removeClass('is-up'); //  is-upというクラス名を除去し
        $('.js-fixed__btn').addClass('is-down');  // is-downというクラス名を追加して非表示
      }
    }

    var scroll = $(window).scrollTop();
    var wH = window.innerHeight;
    var footerPos =  $('.l-footer').offset().top;
    if(scroll+wH >= (footerPos + 8 )) {
      var pos = (scroll+wH) - footerPos + 8;
      $('.js-fixed__btn').css('bottom',pos);
    }else{
      if($('.js-fixed__btn').hasClass('UpMove')){
        $('.js-fixed__btn').css('bottom','10px');
      }
    }
}

$(window).scroll(function () {
  PageTopAnime();
});

$(window).on('load', function () {
  PageTopAnime();
});
  
////////////////////////////////////
//  Accordion
////////////////////////////////////
  
function accordion(){
  $(document).on('click', '.js-accord', function(){
    $(this).next().slideToggle('');
    $(this).toggleClass('is-active');
  });
}

function accordionTarget(){
  $(document).on('click', '.js-accord__target', function(){
    var target = $(this).attr('target');
    $(target).slideToggle('');
    $(this).toggleClass('is-active');
    $(this).parents('.js-accord__parents').toggleClass('is-active');
  });
}

$(function(){
    accordion();
    accordionTarget();
});

////////////////////////////////////
//  Smooth Scroll
////////////////////////////////////
  
function scroll(){

    var headerH = $('.l-header').innerHeight();

    $('a[href^="#"]').click(function(){
      var adjust = 2;
      var speed = 400;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top + adjust - headerH;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
    });

    var urlHash = location.hash;
    if(urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
            var target = $(urlHash);
            var position = target.offset().top - headerH;
            $('body,html').stop().animate({scrollTop:position}, 500);
        }, 100);
    }
}

$(function(){
    //scroll();
});

////////////////////////////////////
//  Single Page
////////////////////////////////////
  
function singlePage(){
  const setFillHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  let vw = window.innerWidth;

  window.addEventListener('resize', () => {
    if (vw === window.innerWidth) {
    　// 画面の横幅にサイズ変動がないので処理を終える
      return;
    }

    // 画面の横幅のサイズ変動があった時のみ高さを再計算する
    vw = window.innerWidth;
    setFillHeight();
  });

  // 初期化
  setFillHeight();
}

$(function(){
    singlePage();
});

$(window).resize(function(){
    singlePage();
});

////////////////////////////////////
//  Navigation Current
////////////////////////////////////

function navigation_current(){
	$('.js-current a').each(function(){
	    var $href = $(this).attr('href');
	    if(location.href.match($href)) {
	        $(this).addClass('is-active');
	        $(this).parents('p').addClass('is-active');
	    } else {
	        $(this).removeClass('is-current');
	    }
	});
}

$(function(){
    navigation_current();
});


////////////////////////////////////
//  Modal
////////////////////////////////////
  
function modal(){
  $(document).on('click', '.js-modal__target', function () {
      var target = $(this).attr('modal-id');
      $('#'+target).stop().fadeIn();
      $('.js-modal__overlay').stop().fadeIn();
      $('.js-modal__close').stop().fadeIn();
      return false;
  });
  $(document).on('click', '.js-modal__close,.js-modal__overlay', function () {
      $('.js-modal__content').stop().fadeOut();
      $('.js-modal__overlay').stop().fadeOut();
      $(this).stop().fadeOut();
      return false;
  });
}

$(function(){
    modal();
});


////////////////////////////////////
//  Tab
////////////////////////////////////
  
function tab(){
  $('.js-tab__item').click(function() {
    var index = $(this).index();
    $('.js-tab__item').removeClass('is-active');
    $('.js-tabmain__item').removeClass('is-active').hide();
    $(this).addClass('is-active');
    $('.js-tabmain__item').eq(index).addClass('is-active').fadeIn();
    $('.js-tab__select').children().eq(index).prop('selected', true);
  });
}

$(function(){
    tab();
});

////////////////////////////////////
//  Animation
////////////////////////////////////
  
function animation(){
  gsap.registerPlugin(ScrollTrigger);

  /* フェードイン */
  gsap.utils.toArray(".js-fadein").forEach(target => {
    ScrollTrigger.matchMedia({
    "(max-width: 767px)": function () {
      gsap.fromTo(target,
        { y: 12, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, delay: 0.4, duration: 0.8, ease: 'Power2.easeOut',
          scrollTrigger: {
            trigger: target,
            start: 'top bottom',
            end: 'bottom top',
            scrub: false,
            markers: false,
            toggleClass: {targets: target, className: "is-active"},
            once: true,
          }
        }
      );
    },
    "(min-width: 768px)": function () {
      gsap.fromTo(target,
        { y: 20, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, delay: 0.4, duration: 0.8, ease: 'Power2.easeOut',
          scrollTrigger: {
            trigger: target,
            start: 'top 70%',
            end: 'bottom top',
            scrub: false,
            markers: false,
            toggleClass: {targets: target, className: "is-active"},
            once: true,
          }
        }
      );
    },
    });
  });


  /* スタッグ */
  const targets = gsap.utils.toArray('.js-fadeinStag');
  targets.forEach((target, i) => {
  	target = gsap.utils.toArray(target.querySelectorAll('.js-fadeinStag__item'));
  	target.forEach((item, i) => {
  	  ScrollTrigger.matchMedia({
  	  "(max-width: 960px)": function () {
  		  const anim = gsap.fromTo(item, {
  		    autoAlpha: 0,
  		    y: 12
  		  }, {
  		    duration: 0.4,
  		    autoAlpha: 1,
  		    y: 0,
  		    delay: 0.25 + (0.25 * i),
  		    onComplete: () => { item.classList.add('is-active'); },
  		    scrollTrigger: {
  		      trigger: item,
  		      start: 'top bottom',
  		      end: 'bottom top',
  		      scrub: false,
  		      markers: false,
  		    }
  		  });
  	  },
  	  "(min-width: 961px)": function () {
  	  	  const anim = gsap.fromTo(item, {
  	  	    autoAlpha: 0,
  	  	    y: 20
  	  	  }, {
  	  	    duration: 0.4,
  	  	    autoAlpha: 1,
  	  	    y: 0,
  	  	    delay: 0.25 + (0.25 * i),
  	  	    onComplete: () => { item.classList.add('is-active'); },
  	  	    scrollTrigger: {
  	  	      trigger: item,
  	  	      start: 'top bottom',
  	  	      end: 'bottom top',
  	  	      scrub: false,
  	  	      markers: false,
  	  	    }
  	  	  });
  	  },
  	  });
  	});
  });

  /* イメージ */
  gsap.utils.toArray(".js-img").forEach(target => {
    ScrollTrigger.matchMedia({
    "(max-width: 767px)": function () {
      gsap.fromTo(target,
        { y: 0, scale: 1.3 },
        { y: 0, scale: 1, delay: 0, duration: 0.8, ease: 'power2.out',
          scrollTrigger: {
            trigger: target,
            start: 'top 150%',
            end: 'bottom 30%',
            scrub: 1.2,
            markers: false,
            toggleClass: {targets: target, className: "is-active"},
          }
        }
      );
    },
    "(min-width: 768px)": function () {
      gsap.fromTo(target,
        { y: 0, scale: 1.3 },
        { y: 0, scale: 1, delay: 0, duration: 0.8, ease: 'power2.out',
          scrollTrigger: {
            trigger: target,
            start: 'top 150%',
            end: 'bottom 30%',
            scrub: 1.8,
            markers: false,
            toggleClass: {targets: target, className: "is-active"},
          }
        }
      );
    },
    });
  })

}

$(function(){
    animation();
});